import { registerPlugin } from '@capacitor/core'

/**
 * The bridge handle for the local `NativeAppCheck` plugin (#467 / #2370).
 * iOS: App Attest, falling back to DeviceCheck. Android: Play Integrity.
 * (spec.md §11.1: "App Check/Attestation משתמש ב-App Attest או DeviceCheck
 * ב-iOS וב-Play Integrity ב-Android".) Same "app-local native plugin, not an
 * npm package" pattern as `nativeNotifications.js` (#1695).
 *
 * The plugin itself is NOT linked yet — that is #2376. Until it is, the bridge
 * has no native header, so `Capacitor.isPluginAvailable('NativeAppCheck')` is
 * false and `adapters/appCheck.js` reports the capability as unavailable.
 *
 * Surface (implemented natively, called ONLY from `adapters/appCheck.js`):
 *  - `getToken()` -> `{token: string, expireTimeMillis: number}` — a fresh App
 *    Check attestation token for the Firebase project this build is bound to.
 *    Deliberately the ONLY method: no path, collection or callable name
 *    crosses this bridge (spec.md §11.1).
 */
export const NativeAppCheck = registerPlugin('NativeAppCheck')

export const NATIVE_APP_CHECK_PLUGIN_NAME = 'NativeAppCheck'
